import React from 'react';
import { Dialog } from '@progress/kendo-react-dialogs';
import './Dialogs.scss';

interface EnrollmentSuccessDialogProps {
  isOpen: boolean;
  generatedCode: string;
  onClose: () => void;
}

const EnrollmentSuccessDialog: React.FC<EnrollmentSuccessDialogProps> = ({ isOpen, generatedCode, onClose }) => {
  if (!isOpen) return null;

  const handleCopyCode = async () => {
    try {
      await navigator.clipboard.writeText(generatedCode);
    } catch (err) {
      const textArea = document.createElement('textarea');
      textArea.value = generatedCode;
      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();
      try {
        document.execCommand('copy');
      } catch (fallbackErr) {
        console.error('Fallback copy failed:', fallbackErr);
      }
      document.body.removeChild(textArea);
    }
  };

  return (
    <Dialog title=" " onClose={onClose} width={500}>
      <div className="offboard-success-dialog">
        <div className="success-checkmark">
          <svg
            width="60"
            height="60"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
            <polyline points="22,4 12,14.01 9,11.01" />
          </svg>
        </div>
        <p className="success-title">New enrollment code generated successfully!</p>
        <div className="enrollment-code-container">
          <p className="enrollment-code-label">Enrollment Code:</p>
          <div className="enrollment-code-wrapper">
            <p className="enrollment-code">{generatedCode}</p>
            <button className="copy-code-button" onClick={handleCopyCode} title="Copy to clipboard">
              <svg
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <rect width="14" height="14" x="8" y="8" rx="2" ry="2" />
                <path d="M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2" />
              </svg>
            </button>
          </div>
        </div>
        <p className="success-subtitle">
          Please save this code! It will be required to sign up in the SpeechDx application.
        </p>
      </div>
    </Dialog>
  );
};

export default EnrollmentSuccessDialog;
